module.exports = __webpack_public_path__ + "img/staff-brian-chladil.59a47a00.jpg";